import { render, staticRenderFns } from "./codeDiff.vue?vue&type=template&id=035ef7e0&"
import script from "./codeDiff.vue?vue&type=script&lang=js&"
export * from "./codeDiff.vue?vue&type=script&lang=js&"
import style0 from "./codeDiff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports